import { observer, useViewModel } from '@descomplica/microfrontend-react';
import React, { useEffect, useState } from 'react';

import { StreamingProviderType } from '@/application/interfaces/classroom/pegasus.gateway';

import Livestream from './components/livestream/livestream';
import { LiveViewModel } from './live.vm';

interface LessonStreamingPlayerProps {
  courseGuid: string;
  streamingGuid: string;
}

export const Live = ({ courseGuid, streamingGuid }: LessonStreamingPlayerProps) => {
  const vm = useViewModel(LiveViewModel);

  const [secondsUntilLive, setSecondsUntilLive] = useState(
    vm.getSecondsUntilDate(vm.streamingInfo?.startStreaming),
  );

  useEffect(() => {
    const intervalId = setInterval(() => {
      const timeUntilLiveStart = vm.getSecondsUntilDate(vm.streamingInfo?.startStreaming);
      setSecondsUntilLive(timeUntilLiveStart);

      if (timeUntilLiveStart <= 0) clearInterval(intervalId);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [vm.streamingInfo?.startStreaming]);

  useEffect(() => {
    const loadLive = async () => {
      if (courseGuid && streamingGuid) await vm.handleScreenEnter(courseGuid, streamingGuid);
    };

    loadLive();
  }, [courseGuid, streamingGuid]);

  return vm.streamingProvider === StreamingProviderType.YOUTUBE && vm.youtubeChatUrl ? (
    <Livestream
      url={vm.youtubeLiveUrl}
      chatUrl={vm.youtubeChatUrl}
      secondsUntilLive={secondsUntilLive}
      showFullscreenChat={vm.showFullscreenChat}
    />
  ) : (
    <Livestream url={vm.livestreamUrl} />
  );
};

export default observer(Live);
